import { Outlet, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Sidebar from "../components/sidebar/sidebar";
import { useLayout } from "../context/layoutContext";
import { SIDEBAR_SECTIONS } from "../constants/sidebar-items";
import { useEffect, useState } from "react";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";

function AdminLayout() {
  const { isSidebarClosed } = useLayout();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const auth = useAuth();
  const location = useLocation();

  const isCompany = auth.userData?.type === "empresa" || auth.userData?.type === "empleado";
  const hasActiveSub = auth.subscription?.active === true;
  const isExcludedRoute = location.pathname.includes("/admin/payments") || location.pathname.includes("/admin/subscriptions");

  const showLockout = isCompany && !hasActiveSub && !isExcludedRoute;

  return (
    <div style={{ minHeight: "100vh", display: "flex" }}>
      <Sidebar items={SIDEBAR_SECTIONS} />
      <Layout
        style={{
          width: isSidebarClosed
            ? `${windowWidth - 110}px`
            : `${windowWidth - 320}px`,
        }}
      >
        <Content>
          <div style={{ padding: "24px", paddingTop: "5px", width: "100%", height: "100%" }}>
            {showLockout ? (
              <div style={{ height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", borderRadius: 8, padding: 40, textAlign: "center" }}>
                <h1 style={{ fontSize: 24, color: "#ff4d4f" }}>Suscripción Inactiva o Pago Pendiente</h1>
                <p style={{ fontSize: 16, color: "#595959", maxWidth: 500 }}>
                  Actualmente no tienes una suscripción activa o tu pago anterior se encuentra pendiente de verificación. Por favor, dirígete a la sección de Pagos para subir tu comprobante correspondiente o regularizar tu cuenta.
                </p>
                <div style={{ marginTop: 24 }}>
                  <a href="/admin/payments" style={{ padding: "10px 20px", background: "#1677ff", color: "white", borderRadius: 6, textDecoration: "none" }}>
                    Ir a Pagos
                  </a>
                </div>
              </div>
            ) : (
              <Outlet />
            )}
          </div>
        </Content>
      </Layout>
    </div>
  );
}

export default AdminLayout;
